<template>
    <div class="flex justify-center items-center h-[300px] w-[100%]">
        <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
        ></v-progress-circular>
    </div>
</template>

<script>
export default {
   name: "LoadingSection",
};
</script>

<style lang="scss" scoped>
/*  */

</style>